export default function() {
  return { type: 'CLOSE_MIDDLEBAR' };
}